import React from 'react';
import {Card, Stack, Typography} from '@mui/material';

/**
 * Summary metric card styled like accounting AR statement cards.
 * Value and optional adornment share the second line; note is a third-line caption.
 */
const StatCard = ({label, value, valueAdornment = null, note = null}) => (
    <Card
        variant="outlined"
        sx={{
            padding: 2,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
        }}
    >
        <Typography variant="body2" fontWeight={500} component="span" color="text.primary">
            {label}
        </Typography>
        <Stack direction="row" alignItems="baseline" spacing={1} flexWrap="wrap" useFlexGap>
            <Typography variant="body1" fontWeight={600} color="secondary.main">
                {value}
            </Typography>
            {valueAdornment && (
                <Typography variant="caption" color="text.secondary" fontWeight={500}>
                    {valueAdornment}
                </Typography>
            )}
        </Stack>
        {note && (
            <Typography variant="caption" color="text.secondary">
                {note}
            </Typography>
        )}
    </Card>
);

export default StatCard;
